import { Pipe, PipeTransform } from '@angular/core';
import {
  TimeFilterService,
  TimeSegment,
} from '@app/shared/services/time-filter.service';

@Pipe({
  name: 'filterTimes',
  standalone: true,
})
export class FilterTimesPipe implements PipeTransform {
  constructor(private timeFilterService: TimeFilterService) {}

  transform<T>(input: T, timeRange: TimeSegment): T;
  transform(input: Date[], timeRange: TimeSegment): any[];
  transform(input: Date[], timeRange: any = ''): any {
    return this.timeFilterService.filterTimesBySegment(input, timeRange);
  }
}
